export const isRecord = (value: unknown): value is Record<string, unknown> =>
  Boolean(value) && typeof value === "object" && !Array.isArray(value);

export const readRecordValue = (source: unknown, ...keys: string[]) => {
  if (!isRecord(source)) return undefined;

  for (const key of keys) {
    const value = source[key];
    if (value !== null && value !== undefined && value !== "") return value;
  }

  return undefined;
};

export const firstNonEmpty = <T>(...values: Array<T | null | undefined>): T | undefined => {
  for (const value of values) {
    if (typeof value === "string") {
      if (value.trim()) return value as T;
      continue;
    }

    if (value !== null && value !== undefined) return value;
  }

  return undefined;
};

export const toStringValue = (value: unknown, fallback = "") =>
  value === null || value === undefined ? fallback : String(value);

export const toBoolean = (value: unknown, fallback = false) => {
  if (typeof value === "boolean") return value;

  if (typeof value === "string") {
    const normalized = value.trim().toLowerCase();
    if (["yes", "true", "1", "y"].includes(normalized)) return true;
    if (["no", "false", "0", "n"].includes(normalized)) return false;
  }

  return fallback;
};

export const normalizeAmountValue = (value: unknown) => {
  if (value === null || value === undefined) return "";

  const numericLike = String(value).replace(/[^\d.]/g, "");
  if (!numericLike) return "";

  const parsed = Number(numericLike);
  if (Number.isNaN(parsed)) return "";

  return String(Math.round(parsed));
};
